<div class="layout has-sidebar fixed-sidebar fixed-header">
  <aside id="sidebar" class="sidebar break-point-lg has-bg-image">
    <div class="sidebar-layout">
      <div
        class="text-center"
        style="padding: 11px 0; border-bottom: 1px solid #dbdfe5"
      >
        <img
          src="/assets/images/Mirl_Logo_Icon_Shadow_Down.png"
          alt="logo"
          id="imgaeexpand"
          style="height: 50px; border-radius: 4px; cursor: pointer; transition: all .1s linear; transform: scaleX(1);"
          routerLink="/user_Management"
        />
        <!-- <img src="./assets/images/mirl_logo3.png" alt="logo" class="imgaecollapse" style="height: 50px; width: 150px; border-radius: 4px" /> -->
      </div>
      <div class="sidebar-content sidevar-item">
        <nav class="menu open-current-submenu">
          <ul>
            <!-- <li class="menu-item">
              <a class="item-div" routerLinkActive="active" routerLink="/dashboard"
                [routerLinkActiveOptions]="{ exact: true }">
                <div class="svg-div">
                  <div class="icon_wrp">
                    <img
                      src="assets/images/dashboard_fill.png"
                      alt=""
                      
                    />
                    <img
                      src="assets/images/dashboard.png"
                      alt=""
                     
                    />
                  </div>
                </div>
                <div class="name-div">
                  <p>Dashboard</p>
                </div>
              </a>
            </li> -->
            <li class="menu-item">
              <a
                class="item-div"
                routerLinkActive="active"
                routerLink="/user_Management"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <div class="svg-div">
                  <div class="icon_wrp">
                    <img
                      src="assets/images/User Management Icon.png"
                      alt=""
                      style="width: 40px"
                    />
                  </div>
                </div>
                <div class="name-div">
                  <p>User Management</p>
                </div>
              </a>
            </li>
            <li class="menu-item">
              <a
                class="item-div"
                routerLinkActive="active"
                routerLink="/delete-account"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <div class="svg-div">
                  <div class="icon_wrp">
                    <img
                      src="assets/images/user.png"
                      alt=""
                      style="width: 40px"
                    />
                  </div>
                </div>
                <div class="name-div">
                  <p>Deleted Accounts</p>
                </div>
              </a>
            </li>

            <li class="menu-item">
              <a
                class="item-div"
                routerLinkActive="active"
                href="Javacsript:void(0)"
                routerLink="category-manage"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <div class="svg-div">
                  <div class="icon_wrp">
                    <img
                      src="assets/images/Category Management Icon.png"
                      alt=""
                      style="width: 40px"
                    />
                  </div>
                </div>
                <div class="name-div">
                  <p>Category Management</p>
                </div>
              </a>
            </li>
            <li class="menu-item">
              <a
                class="item-div"
                routerLinkActive="active"
                href="Javacsript:void(0)"
                routerLink="algo"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <div class="svg-div">
                  <div class="icon_wrp">
                    <img
                      src="assets/images/cogwheel.png"
                      alt=""
                      style="width: 40px"
                    />
                  </div>
                </div>
                <div class="name-div">
                  <p>Algorithm</p>
                </div>
              </a>
            </li>
            <li class="menu-item">
              <a
                class="item-div"
                routerLinkActive="active"
                href="Javacsript:void(0)"
                routerLink="transaction"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <div class="svg-div">
                  <div class="icon_wrp">
                    <img
                      src="assets/images/secure-payment.png"
                      alt=""
                      style="width: 40px"
                    />
                  </div>
                </div>
                <div class="name-div">
                  <p>Transaction</p>
                </div>
              </a>
            </li>
            <li class="menu-item">
              <a
                class="item-div"
                routerLinkActive="active"
                href="Javacsript:void(0)"
                routerLink="refund"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <div class="svg-div">
                  <div class="icon_wrp">
                    <img
                      src="assets/images/reimbursement.png"
                      alt=""
                      style="width: 40px"
                    />
                  </div>
                </div>
                <div class="name-div">
                  <p>Refund</p>
                </div>
              </a>
            </li>
            <li class="menu-item">
              <a
                class="item-div"
                routerLinkActive="active"
                href="Javacsript:void(0)"
                routerLink="media-list"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <div class="svg-div">
                  <div class="icon_wrp">
                    <img
                    src="/assets/images/publicity.png"
                      alt=""
                      style="width: 40px"
                    />
                  </div>
                </div>
                <div class="name-div">
                  <p>Call History</p>
                </div>
              </a>
            </li>

            <li class="menu-item">
              <a
                class="item-div"
                routerLinkActive="active"
                href="Javacsript:void(0)"
                routerLink="topic-manage"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <div class="svg-div">
                  <div class="icon_wrp">
                    <img
                      src="assets/images/Topic Management Icon.png"
                      alt=""
                      style="width: 40px"
                    />
                  </div>
                </div>
                <div class="name-div">
                  <p>Topic Management</p>
                </div>
              </a>
            </li>

            <li class="menu-item">
              <a
                class="item-div"
                routerLinkActive="active"
                href="Javacsript:void(0)"
                routerLink="notification-send"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <div class="svg-div">
                  <div class="icon_wrp">
                    <img
                      src="assets/images/Notification Management Icon.svg"
                      alt=""
                      style="width: 40px"
                    />
                  </div>
                </div>
                <div class="name-div">
                  <p>Notification Management</p>
                </div>
              </a>
            </li>

       
            <li class="menu-item">
              <a
                href="Javacsript:void(0)"
                class="item-div"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                routerLink="/cms"
              >
                <div class="svg-div">
                  <div class="icon_wrp">
                    <img
                      src="assets/images/CMS Icon.png"
                      alt=""
                      style="width: 40px"
                    />
                  </div>
                </div>
                <div class="name-div">
                  <p>CMS</p>
                </div>
              </a>
            </li>
      
              <li class="menu-item sub-menu" (click)="Doctors($event)">
                <a class="drop_link item-div has-child">
                  <div class="svg-div">
                    <div class="icon_wrp">
                      <img
                      src="assets/images/FrameSupportmanagemnt.png"
                      alt=""
                      style="width: 40px"
                    />
                    </div>
                  </div>
                  <div class="name-div">
                    <p>Support Management</p>
                  </div>
                </a>
                <div class="sub-menu-list" data-popper-placement="right">
                  <ul>
                    <li class="menu-item drop_link mb-2 mt-2">
                      <a href="" class="inner-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                        [routerLink]="['/Block-List']">
                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5.86751 4.84571L0.951172 7.98438V0.00404167L5.86551 3.15371C6.00856 3.24363 6.1265 3.36833 6.2083 3.51618C6.29011 3.66402 6.33312 3.83019 6.33332 3.99916C6.33352 4.16813 6.2909 4.33439 6.20945 4.48243C6.12799 4.63047 6.01035 4.75545 5.86751 4.84571Z"
                            fill="#000"></path>
                        </svg>
                      Block List
                      </a>
                    </li>
                    <li class="menu-item">
                      <a href="" class="inner-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                        [routerLink]="['/Report-List']">
                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5.86751 4.84571L0.951172 7.98438V0.00404167L5.86551 3.15371C6.00856 3.24363 6.1265 3.36833 6.2083 3.51618C6.29011 3.66402 6.33312 3.83019 6.33332 3.99916C6.33352 4.16813 6.2909 4.33439 6.20945 4.48243C6.12799 4.63047 6.01035 4.75545 5.86751 4.84571Z"
                            fill="#000"></path>
                        </svg>
                        Report List
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="menu-item sub-menu" (click)="Doctors($event)">
                <a class="drop_link item-div has-child">
                  <div class="svg-div">
                    <div class="icon_wrp">

                      <img
                      src="assets/images/post.png"
                      alt=""
                      style="width: 40px"
                    />
                    </div>
                  </div>
                  <div class="name-div">
                    <p>Sparks Management</p>
                  </div>
                </a>
                <div class="sub-menu-list" data-popper-placement="right">
                  <ul>
                    <li class="menu-item drop_link mb-2 mt-2">
                      <a href="" class="inner-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                        [routerLink]="['post-management']">
                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5.86751 4.84571L0.951172 7.98438V0.00404167L5.86551 3.15371C6.00856 3.24363 6.1265 3.36833 6.2083 3.51618C6.29011 3.66402 6.33312 3.83019 6.33332 3.99916C6.33352 4.16813 6.2909 4.33439 6.20945 4.48243C6.12799 4.63047 6.01035 4.75545 5.86751 4.84571Z"
                            fill="#000"></path>
                        </svg>
                        Sparks
                      </a>
                    </li>
                    <li class="menu-item">
                      <a href="" class="inner-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                        [routerLink]="['/reported-management']">
                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5.86751 4.84571L0.951172 7.98438V0.00404167L5.86551 3.15371C6.00856 3.24363 6.1265 3.36833 6.2083 3.51618C6.29011 3.66402 6.33312 3.83019 6.33332 3.99916C6.33352 4.16813 6.2909 4.33439 6.20945 4.48243C6.12799 4.63047 6.01035 4.75545 5.86751 4.84571Z"
                            fill="#000"></path>
                        </svg>
                        Reported Sparks
                      </a>
                    </li>
                    <li class="menu-item">
                      <a href="" class="inner-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                        [routerLink]="['/comment']">
                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5.86751 4.84571L0.951172 7.98438V0.00404167L5.86551 3.15371C6.00856 3.24363 6.1265 3.36833 6.2083 3.51618C6.29011 3.66402 6.33312 3.83019 6.33332 3.99916C6.33352 4.16813 6.2909 4.33439 6.20945 4.48243C6.12799 4.63047 6.01035 4.75545 5.86751 4.84571Z"
                            fill="#000"></path>
                        </svg>
                        Comments
                      </a>
                    </li>

                    <li class="menu-item">
                      <a href="" class="inner-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                        [routerLink]="['/reported-comment']">
                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5.86751 4.84571L0.951172 7.98438V0.00404167L5.86551 3.15371C6.00856 3.24363 6.1265 3.36833 6.2083 3.51618C6.29011 3.66402 6.33312 3.83019 6.33332 3.99916C6.33352 4.16813 6.2909 4.33439 6.20945 4.48243C6.12799 4.63047 6.01035 4.75545 5.86751 4.84571Z"
                            fill="#000"></path>
                        </svg>
                        Reported Comments
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            <li class="menu-item">
              <a
                href="Javacsript:void(0)"
                class="item-div"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                routerLink="/admin-edit"
              >
                <div class="svg-div">
                  <div class="icon_wrp">
                    <img
                      src="assets/images/Admin Settings Icon.png"
                      alt=""
                      style="width: 40px"
                    />
                  </div>
                </div>
                <div class="name-div">
                  <p>Admin Setting</p>
                </div>
              </a>
            </li>
            <li class="menu-item">
              <a class="item-div" routerLink="/Default-value" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                >
                <div class="svg-div">
                  <div class="icon_wrp">
                    <img
                      src="assets/images/project-managementNew-1.png"
                      alt=""
                      style="width: 40px"
                    />
                  </div>
                </div>
                <div class="name-div">
                  <p>Default-value</p>
                </div>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </aside>
  <div id="overlay" class="overlay"></div>
  <div class="layout">
    <header class="header"></header>
  </div>
</div>
